export interface AreaConfig {
  mode: 'das_based' | 'trip_based' | 'closed';
  trips_per_vessel?: number;
  possession_limit_lbs?: number;
}

export type SamsAccessConfig = Record<string, AreaConfig>;

export const DEFAULT_SAMS_ACCESS_CONFIG: SamsAccessConfig = {
  DMV: { mode: 'das_based' },
  HCS: { mode: 'das_based' },
  NYB: { mode: 'das_based' },
  NLSWest: { mode: 'das_based' },
  NLSDeep: { mode: 'das_based' },
  NLSCentral: { mode: 'das_based' },
  NLSSouth: { mode: 'das_based' },
  CA1: { mode: 'trip_based', trips_per_vessel: 1, possession_limit_lbs: 12000 },
  'CA2-N': { mode: 'trip_based', trips_per_vessel: 1, possession_limit_lbs: 12000 },
  'CA2-S': { mode: 'closed' },
  'ET-Flex': { mode: 'das_based' },
  'ET-Open': { mode: 'das_based' },
  'HC-Inshore': { mode: 'das_based' },
  SCB: { mode: 'das_based' },
  'Elephant-Trunk': { mode: 'das_based' },
  'Nantucket-Lightship': { mode: 'das_based' },
};
